// src/environment/images.ts
export const IMAGES = {
    GOOGLE_LOGO: '/assets/google.png',
    CLINICORP_LOGO: '/assets/clinicorp.png'
  }; 